const authActons = {
  LOGIN_REQUEST: "LOGIN_REQUEST",
  LOGOUT: "LOGOUT",
  LOGIN_SUCCESS: "LOGIN_SUCCESS",
  LOGIN_ERROR: "LOGIN_ERROR",
  CHECK_LOGGED_IN: "CHECK_LOGGED_IN",
  LOGGED_IN: "LOGGED_IN",
  USER_AUTH_PROFILE: "USER_AUTH_PROFILE",
  ISCHECKING_LOGGED_IN: "ISCHECKING_LOGGED_IN",

  login: () => ({
    type: authActons.LOGIN_REQUEST,
  }),
  logout: () => ({
    type: authActons.LOGOUT,
  }),
  checkIsLoggedIn: () => ({
    type: authActons.CHECK_LOGGED_IN,
  }),
};

export default authActons;
